<template>
  <div v-if="itemPackage" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="itemPackage">
      <ItemPackageForm
        :itemPackage="itemPackage"
        @update:itemPackage="itemPackageLocalUpdate"
        @save="handleSave"
      />

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showDeleteButton="buttons.showDeleteButton"
            :model="itemPackage"
            modelEditRoute="ItemPackageEditPage"
            modelListRoute="ItemPackagesPage"
            modelRouteParamName="itemPackageNumber"
            :updateCallback="updateItemPackage"
            :createCallback="createItemPackage"
            :deleteCallback="deleteItemPackage"
            :fetchPaginatedCallback="fetchItemPackagesPaginated"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';
import ItemPackageForm from '@/components/ItemPackages/ItemPackageForm.vue';

export default {
  name: 'ItemPackageEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
    ItemPackageForm,
  },
  props: {
    itemPackageNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
    };
  },
  computed: {
    ...mapGetters(['getItemPackageByNumber']),
    buttons() {
      return {
        showDeleteButton: this.itemPackage && this.itemPackage.number !== '_new' ? true : false,
      };
    },
    itemPackage() {
      return this.getItemPackageByNumber(this.number);
    },
    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        { name: this.$t('itemPackages'), route: { name: 'ItemPackagesPage' } },
        { name: this.itemPackage.number !== '_new' ? this.$t('edit') : this.$t('new') },
      ];
    },
  },
  methods: {
    ...mapActions([
      'fetchItemPackagesPaginated',
      'fetchItemPackageByNumber',
      'updateItemPackage',
      'createItemPackage',
      'deleteItemPackage',
      'initItemPackage',
      'itemPackageLocalUpdate',
    ]),

    async handleSave(itemPackage) {
      if (itemPackage.number === '_new') {
        await this.createItemPackage(itemPackage);
      } else {
        await this.updateItemPackage(itemPackage);
      }
    },
  },
  async mounted() {
    console.log('ItemPackageEdit:mounted', this.itemPackageNumber);
    if (!this.itemPackage && this.itemPackageNumber) {
      this.number = this.itemPackageNumber;
      await this.fetchItemPackageByNumber(this.number);
    } else {
      this.initItemPackage();
      this.number = '_new';
    }
  },
  watch: {
    itemPackage(newValue, oldValue) {
      console.log('ItemPackageEdit:itemPackage changed', newValue);
    },
  },
};
</script>

<style scoped lang="scss">
.p-calendar {
  width: 100%;
}
</style>
